import { Pipe, PipeTransform, inject } from '@angular/core';
import { startCase } from 'lodash';
import { TransactionTypeLabel } from 'src/app/default/employees/enum';

import { BrandService } from '../services/brand.service';

@Pipe({ name: 'transactionType' })
export class TransactionTypePipe implements PipeTransform {
  private brandService = inject(BrandService);

  public static formatTransactionType(value: TransactionTypeLabel, brandService: BrandService): string {
    switch (value) {
      case TransactionTypeLabel.ACH:
      case TransactionTypeLabel.ATM:
        return value.toLocaleUpperCase();

      case TransactionTypeLabel.ClaimConneXRequest:
        return 'Claim ConneX Request';

      case TransactionTypeLabel.CompanyCard:
        return startCase(brandService.getBrandResources()?.companyCard) || '';

      default:
        return startCase(value);
    }
  }

  public transform(value: TransactionTypeLabel): string {
    return TransactionTypePipe.formatTransactionType(value, this.brandService);
  }
}
